export default (params) => ({
  trigger: {
    name: 'product_sub_title.select_all_accessories',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'accessories',
      },
    },
  },
});
